import React from 'react';

import { SidebarLink } from 'components/common/tableComponents/cellTemplates';

export const ApprovalSidebarLink = (componentName, subFieldName, getValue) => (
    function ApprovalSidebarLink ({ item, value, ...props }) {
        const val = getValue ?  getValue(item) : value;

        return (
            <div className="sidebar-container">
                <SidebarLink {...props} item={item} value={val} componentName={componentName} />
                <br />
                <span className="lv-small">{item[subFieldName]}</span>
            </div>
        );
    }
);
